// Custom Reducer used for filtering agenda items
import { useState } from "react";
import { atom, useRecoilState } from "recoil";

export const videosFilterState = atom({
  key: "videoFilter",
  default: [],
});

export const videosListState = atom({
  key: "videoList",
  default: [],
});

export const videoDateState = atom({
  key: "videoDate",
  default: { name: "2026", id: "2026" },
});
export const liveFeedState = atom({
  key: "liveFeed",
  default: null,
});
export const showLiveState = atom({
  key: "showLive",
  default: false,
});
export const sectionState = atom({
  key: "videoSection",
  default: "council",
});

import { apiGetVideosBySection } from "../../lib/api/engage";

export default function useVideoFilter() {
  const [filteredVideos, setFilteredVideos] = useRecoilState(videosFilterState);
  const [fetching, setFetching] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedDate, setSelectedDate] = useRecoilState(videoDateState);
  const [videoList, setVideoList] = useRecoilState(videosListState);
  const [liveFeed, setLiveFeed] = useRecoilState(liveFeedState);
  const [showLive, setShowLive] = useRecoilState(showLiveState);
  const [videoSection, setVideoSection] = useRecoilState(sectionState);

  async function videoDispatch(action) {
    switch (action.type) {
      case "FETCH_DATA":
        const result = await apiGetVideosBySection(
          action.client,
          selectedDate.id,
          videoSection
        );
        if (result) {
          setVideoList(result.videos);
          setFilteredVideos(result.videos);
          if (result.cablecastLiveUrl.length > 0) {
            setLiveFeed(result.cablecastLiveUrl);
            setShowLive(result.embedLive);
          }
        }
        break;
      case "RESET":
        setFilterText("");
        break;
      case "TAB":
        switch (action.value) {
          case 0:
            setFilterText("");
            setVideoList([]);
            setFilteredVideos([]);
            break;
          case 1:
            setFilterText("");
            setVideoList([]);
            setFilteredVideos([]);
            setVideoSection("council");
            const councilResult = await apiGetVideosBySection(
              action.client,
              selectedDate.id,
              "council"
            );
            if (councilResult) {
              setVideoList(councilResult.videos);
              setFilteredVideos(councilResult.videos);
              if (councilResult.cablecastLiveUrl.length > 0) {
                setLiveFeed(councilResult.cablecastLiveUrl);
                setShowLive(councilResult.embedLive);
              }
            }
            break;
          case 2:
            setFilterText("");
            setVideoList([]);
            setFilteredVideos([]);
            let boardType = "boards";
            if (action.client === "grapevinetx") {
              setVideoSection("council");
              boardType = "council";
            } else {
              setVideoSection("boards");
            }
            const boardResult1 = await apiGetVideosBySection(
              action.client,
              selectedDate.id,
              boardType
            );
            if (boardResult1) {
              setVideoList(boardResult1.videos);
              setFilteredVideos(boardResult1.videos);
              if (boardResult1.cablecastLiveUrl.length > 0) {
                setLiveFeed(boardResult1.cablecastLiveUrl);
                setShowLive(boardResult1.embedLive);
              }
            }
            break;
          case 3:
            setFilterText("");
            setVideoList([]);
            setFilteredVideos([]);
            setVideoSection("boards");
            const boardResult = await apiGetVideosBySection(
              action.client,
              selectedDate.id,
              "boards"
            );
            if (boardResult) {
              setVideoList(boardResult.videos);
              setFilteredVideos(boardResult.videos);
              if (boardResult.cablecastLiveUrl.length > 0) {
                setLiveFeed(boardResult.cablecastLiveUrl);
                setShowLive(boardResult.embedLive);
              }
            }
            break;

          default:
            break;
        }
        setFilterText("");
        break;
      case "SET_DATE":
        setFilterText("");
        setSelectedDate(action.payload);
        setVideoList([]);
        setFilteredVideos([]);
        const dateResult = await apiGetVideosBySection(
          action.client,
          action.payload.id,
          videoSection
        );
        if (dateResult) {
          setVideoList(dateResult.videos);
          setFilteredVideos(dateResult.videos);
          if (dateResult.cablecastLiveUrl.length > 0) {
            setLiveFeed(dateResult.cablecastLiveUrl);
            setShowLive(dateResult.embedLive);
          }
        }
        break;
      case "FILTER_DATE":
        setFilterText(action.payload);

        const dateKey = action.payload;
        const dateLowerKey = dateKey.toLowerCase();
        if (dateKey !== "") {
          const dateResults = videoList.filter((y) => {
            let item = y.scheduleDate.split(",")[0].toLowerCase();
            return item.indexOf(dateLowerKey) !== -1;
          });
          setFilteredVideos(dateResults);
        } else {
          setFilteredVideos(videoList);
        }
        break;
      default:
        break;
    }
  }

  return {
    videoDispatch,
    videos: filteredVideos,
    fetching,
    filterText,
    liveFeed,
    showLive,
    selectedDate,
  };
}
